import {ReactNode} from "react";
import {Navigate} from "react-router-dom";
import Storage from "../storage/Storage";

type SecuredProps = {
    children: ReactNode;
}

/**
 * Renders component only if token is in Storage [does not validate this token].
 * Otherwise, redirects to /login page.
 * @param props
 * @constructor
 */
function Secured(props: SecuredProps) {
    if (!Storage.getToken()) {
        return (
            <Navigate
                replace
                to="/login"
            />
        );
    }

    return (
        <>
            { props.children }
        </>
    );
}

export default Secured;